import { Routes, Route } from "react-router-dom";
// import "react-notifications/lib/notifications.css";
// import { NotificationContainer } from "react-notifications";
import Header from "./components/App/Header";
import Home from "./components/Pages/Home";
import VerifyCR from "./components/Pages/VerifyCR";
import RequireAuth from "./components/RequireAuth";
import { useState, useEffect } from "react";
import AppContext from "./components/Context/Context";
import TrendReport from "./components/Pages/TrendReport";
import RetailerScorecard from "./components/Pages/RetailerScorecard";
import Input from "./components/Pages/Input";
import NSAScorecard from "./components/Pages/NSAScorecard";
import YTDLeagueTableTrends from "./components/Pages/YTDLeagueTableTrends";
import MonthLeagueTable from "./components/Pages/MonthLeagueTable";
import YTDLeagueTable from "./components/Pages/YTDLeagueTable";
import RequireAuthAdmin from "./components/RequireAuthAdmin";
function App() {
  return (
    <main>
      {/* <NotificationContainer /> */}
      <div className="App--main">
        <Header />
        <div className="Body--Main">
          <Routes>
            <Route
              path=""
              element={
                <RequireAuth>
                  <Home />
                </RequireAuth>
              }
            />
            <Route
              path="home"
              element={
                <RequireAuth>
                  <Home />
                </RequireAuth>
              }
            />
            <Route path="verifycr" element={<VerifyCR />} />
            <Route
              path="trendreport"
              element={
                <RequireAuth>
                  <TrendReport />
                </RequireAuth>
              }
            />
            <Route
              path="retailerscorecard"
              element={
                <RequireAuth>
                  <RetailerScorecard />
                </RequireAuth>
              }
            />
            <Route
              path="networkscorecard"
              element={
                <RequireAuth>
                  <NSAScorecard ScreenID={4} />
                </RequireAuth>
              }
            />
            <Route
              path="salesscorecard"
              element={
                <RequireAuth>
                  <NSAScorecard ScreenID={5} />
                </RequireAuth>
              }
            />
            <Route
              path="aftersalesscorecard"
              element={
                <RequireAuth>
                  <NSAScorecard ScreenID={6} />
                </RequireAuth>
              }
            />
            <Route
              path="input"
              element={
                <RequireAuthAdmin>
                  <Input />
                </RequireAuthAdmin>
              }
            />

            <Route
              path="ytdleagueTable"
              element={
                <RequireAuth>
                  <YTDLeagueTable />
                </RequireAuth>
              }
            />
            <Route
              path="monthleaguetable"
              element={
                <RequireAuth>
                  <MonthLeagueTable />
                </RequireAuth>
              }
            />
            <Route
              path="ytdleaguetabletrends"
              element={
                <RequireAuth>
                  <YTDLeagueTableTrends />
                </RequireAuth>
              }
            />
          </Routes>
        </div>
      </div>
    </main>
  );
}

export default App;
